// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeSidebar_drawer__YAobF {
  border-radius: 20px;
  width: 360px;
  /* transition: background-color 0.5s ease-out; */
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(184, 184, 184, 0.1) transparent;
  scroll-margin-top: 80px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  z-index: 6;
  position: relative;
}
.ThemeSidebar_allSystemsContainer__cexlt {
  transition: all 0.6s ease-out;
  position: absolute;
  /* top: 100px; */
  top: 0;
  height: 100%;
  width: 100%;
  /* height: calc(100% - 100px); */
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: transparent;
  z-index: 6;
}
.ThemeSidebar_selectedSystem__tsnMp {
  transition: all 0.5s ease-out;
  width: 100%;
  height: 100%;
}
.ThemeSidebar_hideSelectedSystem__\\+4Xd9 {
  transform: translateX(101%);
}
.ThemeSidebar_showSelectedSystem__TcTF0 {
  transform: translateX(0);
}
.ThemeSidebar_allSystemsContainer__cexlt::-webkit-scrollbar {
  display: none;
}
.ThemeSidebar_showAllSystems__6JeGX {
  transform: translateX(0);
}
.ThemeSidebar_hideAllSystems__UzMqW {
  transform: translateX(-101%);
}
.ThemeSidebar_systemContainer__CWKEg {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  cursor: pointer;
  overflow: hidden;
}
.ThemeSidebar_dashBoardContainer__IJVse {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 12px;
  padding: 0 28px;
  cursor: pointer;
}
.ThemeSidebar_drawer__YAobF::-webkit-scrollbar {
  display: none;
}
.ThemeSidebar_corrector__8gFPv {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 740px;
}
.ThemeSidebar_correctorParts__k4Wwu {
  width: 100%;
  /* height: 100%; */
}
.ThemeSidebar_drawerIncorrectLtr__sUW\\+8 {
  direction: ltr;
}
.ThemeSidebar_drawerIncorrectRtl__8\\+EmZ {
  direction: rtl;
}
.ThemeSidebar_rtlDirectionCorrector__BFCXB {
  direction: rtl;
}
.ThemeSidebar_ltrDirectionCorrector__0DE3h {
  direction: ltr;
}
.ThemeSidebar_drawerAndTogglerContainer__OjCbw {
  display: flex;
  height: 100%;
}
.ThemeSidebar_drawer__YAobF::-webkit-scrollbar {
  width: 10px;
  background-color: transparent;
  border-radius: 10000%;
}
.ThemeSidebar_drawer__YAobF::-webkit-scrollbar-thumb {
  /* ****************** DO NOT DELETE THIS ******************** background: linear-gradient(to bottom, transparent 10%, #efefef 20%, #efefef 80%, transparent 90%); ****************** DO NOT DELETE THIS ********************/
  background-color: transparent;
}
.ThemeSidebar_drawer__YAobF::-webkit-scrollbar-track {
  background: transparent;
}
.ThemeSidebar_togglerIconContainer__tgEDj {
  width: 17px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-end-end-radius: 8px;
  border-start-end-radius: 8px;
  z-index: 5;
  cursor: pointer;
  margin-top: 93px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
/*.togglerIconRtlLan {
  transform: translate(27px, 35px); 
  margin-right: -27px;
}
.togglerIconLtrLan {
  margin-left: -27px;
   transform: translate(-23px, 35px);
} */
.ThemeSidebar_rtlSystemArrow__iexnN {
  transform: rotate(0);
}
.ThemeSidebar_ltrSystemArrow__quQ1b {
  transform: rotate(180deg);
}
.ThemeSidebar_whiteTheme__YgIdr {
  background-color: #fff;
  /* border: 1px solid #dbcdff; */
}
.ThemeSidebar_gradientTheme__UK3M3 {
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(222, 210, 255, 1) 100%);
  /* border: 1px solid #dbcdff; */
}
.ThemeSidebar_pinkTheme__zUwnW {
  background-color: #f5f5f5;
  /* border: 1px solid #dbcdff; */
}
.ThemeSidebar_darkTheme__ZJ7Sp {
  background-color: var(--sidebar-background-color);
  color: #b7b9bd;
  /* border: 1px solid #98b3dc; */
}
.ThemeSidebar_BlueTheme__ke09v {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgb(205, 233, 255) 50%,
    rgb(128, 198, 255) 100%
  );
  /* border: none; */
}
.ThemeSidebar_whiteBGC__Ob48Z {
  background-color: #fff;
}
.ThemeSidebar_gradientBGC__HM-Rt {
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgb(222, 210, 255, 1) 100%);
}
.ThemeSidebar_pinkBGC__TeTQk {
  background-color: #f5f5f5;
}
.ThemeSidebar_darkBGC__jq5Pi {
  background-color: var(--sidebar-background-color);
  color: #fff;
}
.ThemeSidebar_BlueBGC__ZtW5g {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgb(205, 233, 255) 50%,
    rgb(128, 198, 255) 100%
  );
}
.ThemeSidebar_logoContainer__HFbvi {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px 0;
}
.ThemeSidebar_logo__nEvwW {
  width: 135px;
  height: 68px;
  cursor: pointer;
}
.ThemeSidebar_systemTitleContainer__rXEjE {
  /* padding: 10px 42px 20px 42px; */
  column-gap: 12px;
  padding-block-start: 7px;
  padding-block-end: 16px;
  padding-inline-start: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.ThemeSidebar_darkThemeSystemTitleContainer__DwNFA {
  color: #fff;
}
.ThemeSidebar_BarkThemeSystemTitleContainer__Mxges {
  color: #000;
}
.ThemeSidebar_systemTitle__7AcRz {
  font-size: 20px;
  font-weight: 500;
  line-height: 31px;
  letter-spacing: 0em;
  /* padding-inline-start: 16px; */
}
.ThemeSidebar_searchInputContainer__oU2tH {
  /* padding: 10px 42px; */
  padding-inline-start: 22px;
  padding-inline-end: 28px;
  position: relative;
}
.ThemeSidebar_allSystemSearchContainer__TKbR8 {
  padding-inline-start: 22px;
  padding-inline-end: 28px;
  margin-block-start: 7px;
  height: 45px;
}
.ThemeSidebar_searchLabel__8pW5n {
  margin-inline-start: 15px;
  display: flex;
  align-items: center;
  column-gap: 6px;
  font-size: 14px;
  margin-bottom: -25px;
}
.ThemeSidebar_allSystemSearchInput__M\\+hcc {
  background-color: transparent;
  width: 100%;
  border: none;
  border-bottom: 1px solid #9a9a9a;
  color: inherit;
  padding: 5px;
}
.ThemeSidebar_searchInput__GkaZa {
  background-color: transparent;
  width: 100%;
  border: none;
  border-bottom: 1px solid #9a9a9a;
  color: inherit;
  padding: 5px;
}
.ThemeSidebar_allSystemSearchplaceholder__nWmdc {
  display: flex;
  align-items: center;
  column-gap: 12px;
  margin-top: -30px;
  margin-inline-start: 10px;
  color: #9a9a9a;
  z-index: 1;
  cursor: text;
}
.ThemeSidebar_placeholder__mBo8F {
  position: absolute;
  display: flex;
  align-items: center;
  column-gap: 12px;
  margin-top: -30px;
  margin-inline-start: 10px;
  color: #9a9a9a;
  z-index: 1;
  cursor: text;
}
.ThemeSidebar_searchIcon__cufuh {
  color: #9a9a9a;
  fill: #9a9a9a;
}
.ThemeSidebar_navigationContainer__5Bd7i {
  padding-top: 16px;
  /* padding-inline-start: 28px; */
}
.ThemeSidebar_line__xyXNK {
  background-color: #9a9a9a;
  height: 1px;
  margin-inline: 28px;
  margin-block: 10px;
}
.ThemeSidebar_allSystemLine__QGZFx {
  background-color: #9a9a9a;
  height: 1px;
  /* margin-inline: 28px;
  margin-block: 24px; */
}
.ThemeSidebar_constPartContainer__0pGO5 {
  padding-bottom: 70px;
  /* padding-top: 15px; */
}
.ThemeSidebar_userInfoContainer__DcO93 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  width: calc(100% - 23px);
  padding-inline-start: 15px;
  padding-inline-end: 20px;
  /* padding-bottom: 5px; */
  /* padding-top: 5px; */
  height: 80px;
  border-end-end-radius: 20px;
  border-end-start-radius: 20px;
  z-index: 7;
  /* margin-inline-start: 10px; */
}
.ThemeSidebar_userInfoContainerRtlLan__dxk0w {
  right: 0;
}
.ThemeSidebar_userInfoContainerLtrLan__uo7md {
  left: 0;
}
.ThemeSidebar_toggler__o9zrm {
  transition: all 0.3s ease-out !important;
}
.ThemeSidebar_ltrOpenedToggler__hZ9VG {
  transform: rotate(180deg);
  margin-inline-end: -4px;
}
.ThemeSidebar_ltrClosedToggler__ULe6k {
  transform: rotate(0);
  /* margin-inline-end: -3px; */
  /* margin-inline-end: 3px; */
}
.ThemeSidebar_rtlOpenedToggler__Jz7Uu {
  transform: rotate(180deg);
  /* margin-inline-end: 3px; */
}
.ThemeSidebar_rtlClosedToggler__Ojum\\+ {
  transform: rotate(0);
  margin-inline-end: -4px;
}
.ThemeSidebar_ltrSystemTitleToggler__ZOPo\\+ {
  transform: rotate(180deg);
}
.ThemeSidebar_rtlSystemTitleToggler__jrs1j {
  transform: rotate(0);
}
/* .searchInput {
  background-color: transparent;
  border: none;
  outline: none;
} */
@media all and (max-width: 1700px) {
  .ThemeSidebar_drawer__YAobF {
    width: 330px;
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: 330px;
  }
}
@media all and (max-width: 1500px) {
  .ThemeSidebar_drawer__YAobF {
    width: 310px;
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: 310px;
  }
}
@media all and (max-width: 1400px) {
  .ThemeSidebar_drawer__YAobF {
    width: 295px;
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: 295px;
  }
}
@media all and (max-width: 1300px) {
  .ThemeSidebar_drawer__YAobF {
    width: 290px;
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: 290px;
  }
}
@media all and (max-width: 1100px) {
  .ThemeSidebar_drawer__YAobF {
    width: 360px;
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: calc(100% - 23px);
  }
}
@media all and (max-width: 600px) {
  .ThemeSidebar_drawer__YAobF {
    width: 300px;
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: 300px;
  }
}
@media all and (max-width: 400px) {
  .ThemeSidebar_drawer__YAobF {
    width: calc(100% - 2px);
  }
  .ThemeSidebar_userInfoContainer__DcO93 {
    width: calc(100% - 20px);
    padding-inline-end: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ThemeSidebar/ThemeSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;EACrD,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;;EAErB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,4NAA4N;EAC5N,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;;;;;;;GAOG;AACH;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,0FAA0F;EAC1F,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,iDAAiD;EACjD,cAAc;EACd,+BAA+B;AACjC;AACA;EACE;;;;;GAKC;EACD,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yFAAyF;AAC3F;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iDAAiD;EACjD,WAAW;AACb;AACA;EACE;;;;;GAKC;AACH;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX;uBACqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,QAAQ;AACV;AACA;EACE,OAAO;AACT;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;;;;GAIG;AACH;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;AACF","sourcesContent":[".drawer {\r\n  border-radius: 20px;\r\n  width: 360px;\r\n  /* transition: background-color 0.5s ease-out; */\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(184, 184, 184, 0.1) transparent;\r\n  scroll-margin-top: 80px;\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n\r\n  z-index: 6;\r\n  position: relative;\r\n}\r\n.allSystemsContainer {\r\n  transition: all 0.6s ease-out;\r\n  position: absolute;\r\n  /* top: 100px; */\r\n  top: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  /* height: calc(100% - 100px); */\r\n  overflow-y: auto;\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n  background-color: transparent;\r\n  z-index: 6;\r\n}\r\n.selectedSystem {\r\n  transition: all 0.5s ease-out;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.hideSelectedSystem {\r\n  transform: translateX(101%);\r\n}\r\n.showSelectedSystem {\r\n  transform: translateX(0);\r\n}\r\n.allSystemsContainer::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n.showAllSystems {\r\n  transform: translateX(0);\r\n}\r\n.hideAllSystems {\r\n  transform: translateX(-101%);\r\n}\r\n.systemContainer {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 28px;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n}\r\n.dashBoardContainer {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  column-gap: 12px;\r\n  padding: 0 28px;\r\n  cursor: pointer;\r\n}\r\n.drawer::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n.corrector {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  min-height: 740px;\r\n}\r\n.correctorParts {\r\n  width: 100%;\r\n  /* height: 100%; */\r\n}\r\n.drawerIncorrectLtr {\r\n  direction: ltr;\r\n}\r\n.drawerIncorrectRtl {\r\n  direction: rtl;\r\n}\r\n.rtlDirectionCorrector {\r\n  direction: rtl;\r\n}\r\n.ltrDirectionCorrector {\r\n  direction: ltr;\r\n}\r\n.drawerAndTogglerContainer {\r\n  display: flex;\r\n  height: 100%;\r\n}\r\n.drawer::-webkit-scrollbar {\r\n  width: 10px;\r\n  background-color: transparent;\r\n  border-radius: 10000%;\r\n}\r\n.drawer::-webkit-scrollbar-thumb {\r\n  /* ****************** DO NOT DELETE THIS ******************** background: linear-gradient(to bottom, transparent 10%, #efefef 20%, #efefef 80%, transparent 90%); ****************** DO NOT DELETE THIS ********************/\r\n  background-color: transparent;\r\n}\r\n.drawer::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n.togglerIconContainer {\r\n  width: 17px;\r\n  height: 56px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  border-end-end-radius: 8px;\r\n  border-start-end-radius: 8px;\r\n  z-index: 5;\r\n  cursor: pointer;\r\n  margin-top: 93px;\r\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n}\r\n/*.togglerIconRtlLan {\r\n  transform: translate(27px, 35px); \r\n  margin-right: -27px;\r\n}\r\n.togglerIconLtrLan {\r\n  margin-left: -27px;\r\n   transform: translate(-23px, 35px);\r\n} */\r\n.rtlSystemArrow {\r\n  transform: rotate(0);\r\n}\r\n.ltrSystemArrow {\r\n  transform: rotate(180deg);\r\n}\r\n.whiteTheme {\r\n  background-color: #fff;\r\n  /* border: 1px solid #dbcdff; */\r\n}\r\n.gradientTheme {\r\n  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(222, 210, 255, 1) 100%);\r\n  /* border: 1px solid #dbcdff; */\r\n}\r\n.pinkTheme {\r\n  background-color: #f5f5f5;\r\n  /* border: 1px solid #dbcdff; */\r\n}\r\n.darkTheme {\r\n  background-color: var(--sidebar-background-color);\r\n  color: #b7b9bd;\r\n  /* border: 1px solid #98b3dc; */\r\n}\r\n.BlueTheme {\r\n  background: linear-gradient(\r\n    90deg,\r\n    rgba(255, 255, 255, 1) 0%,\r\n    rgb(205, 233, 255) 50%,\r\n    rgb(128, 198, 255) 100%\r\n  );\r\n  /* border: none; */\r\n}\r\n.whiteBGC {\r\n  background-color: #fff;\r\n}\r\n.gradientBGC {\r\n  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgb(222, 210, 255, 1) 100%);\r\n}\r\n.pinkBGC {\r\n  background-color: #f5f5f5;\r\n}\r\n.darkBGC {\r\n  background-color: var(--sidebar-background-color);\r\n  color: #fff;\r\n}\r\n.BlueBGC {\r\n  background: linear-gradient(\r\n    90deg,\r\n    rgba(255, 255, 255, 1) 0%,\r\n    rgb(205, 233, 255) 50%,\r\n    rgb(128, 198, 255) 100%\r\n  );\r\n}\r\n.logoContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 9px 0;\r\n}\r\n.logo {\r\n  width: 135px;\r\n  height: 68px;\r\n  cursor: pointer;\r\n}\r\n.systemTitleContainer {\r\n  /* padding: 10px 42px 20px 42px; */\r\n  column-gap: 12px;\r\n  padding-block-start: 7px;\r\n  padding-block-end: 16px;\r\n  padding-inline-start: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n.darkThemeSystemTitleContainer {\r\n  color: #fff;\r\n}\r\n.BarkThemeSystemTitleContainer {\r\n  color: #000;\r\n}\r\n.systemTitle {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 31px;\r\n  letter-spacing: 0em;\r\n  /* padding-inline-start: 16px; */\r\n}\r\n.searchInputContainer {\r\n  /* padding: 10px 42px; */\r\n  padding-inline-start: 22px;\r\n  padding-inline-end: 28px;\r\n  position: relative;\r\n}\r\n.allSystemSearchContainer {\r\n  padding-inline-start: 22px;\r\n  padding-inline-end: 28px;\r\n  margin-block-start: 7px;\r\n  height: 45px;\r\n}\r\n.searchLabel {\r\n  margin-inline-start: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 6px;\r\n  font-size: 14px;\r\n  margin-bottom: -25px;\r\n}\r\n.allSystemSearchInput {\r\n  background-color: transparent;\r\n  width: 100%;\r\n  border: none;\r\n  border-bottom: 1px solid #9a9a9a;\r\n  color: inherit;\r\n  padding: 5px;\r\n}\r\n.searchInput {\r\n  background-color: transparent;\r\n  width: 100%;\r\n  border: none;\r\n  border-bottom: 1px solid #9a9a9a;\r\n  color: inherit;\r\n  padding: 5px;\r\n}\r\n.allSystemSearchplaceholder {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 12px;\r\n  margin-top: -30px;\r\n  margin-inline-start: 10px;\r\n  color: #9a9a9a;\r\n  z-index: 1;\r\n  cursor: text;\r\n}\r\n.placeholder {\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 12px;\r\n  margin-top: -30px;\r\n  margin-inline-start: 10px;\r\n  color: #9a9a9a;\r\n  z-index: 1;\r\n  cursor: text;\r\n}\r\n.searchIcon {\r\n  color: #9a9a9a;\r\n  fill: #9a9a9a;\r\n}\r\n.navigationContainer {\r\n  padding-top: 16px;\r\n  /* padding-inline-start: 28px; */\r\n}\r\n.line {\r\n  background-color: #9a9a9a;\r\n  height: 1px;\r\n  margin-inline: 28px;\r\n  margin-block: 10px;\r\n}\r\n.allSystemLine {\r\n  background-color: #9a9a9a;\r\n  height: 1px;\r\n  /* margin-inline: 28px;\r\n  margin-block: 24px; */\r\n}\r\n.constPartContainer {\r\n  padding-bottom: 70px;\r\n  /* padding-top: 15px; */\r\n}\r\n.userInfoContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: absolute;\r\n  bottom: 0px;\r\n  width: calc(100% - 23px);\r\n  padding-inline-start: 15px;\r\n  padding-inline-end: 20px;\r\n  /* padding-bottom: 5px; */\r\n  /* padding-top: 5px; */\r\n  height: 80px;\r\n  border-end-end-radius: 20px;\r\n  border-end-start-radius: 20px;\r\n  z-index: 7;\r\n  /* margin-inline-start: 10px; */\r\n}\r\n.userInfoContainerRtlLan {\r\n  right: 0;\r\n}\r\n.userInfoContainerLtrLan {\r\n  left: 0;\r\n}\r\n.toggler {\r\n  transition: all 0.3s ease-out !important;\r\n}\r\n.ltrOpenedToggler {\r\n  transform: rotate(180deg);\r\n  margin-inline-end: -4px;\r\n}\r\n.ltrClosedToggler {\r\n  transform: rotate(0);\r\n  /* margin-inline-end: -3px; */\r\n  /* margin-inline-end: 3px; */\r\n}\r\n.rtlOpenedToggler {\r\n  transform: rotate(180deg);\r\n  /* margin-inline-end: 3px; */\r\n}\r\n.rtlClosedToggler {\r\n  transform: rotate(0);\r\n  margin-inline-end: -4px;\r\n}\r\n.ltrSystemTitleToggler {\r\n  transform: rotate(180deg);\r\n}\r\n.rtlSystemTitleToggler {\r\n  transform: rotate(0);\r\n}\r\n/* .searchInput {\r\n  background-color: transparent;\r\n  border: none;\r\n  outline: none;\r\n} */\r\n@media all and (max-width: 1700px) {\r\n  .drawer {\r\n    width: 330px;\r\n  }\r\n  .userInfoContainer {\r\n    width: 330px;\r\n  }\r\n}\r\n@media all and (max-width: 1500px) {\r\n  .drawer {\r\n    width: 310px;\r\n  }\r\n  .userInfoContainer {\r\n    width: 310px;\r\n  }\r\n}\r\n@media all and (max-width: 1400px) {\r\n  .drawer {\r\n    width: 295px;\r\n  }\r\n  .userInfoContainer {\r\n    width: 295px;\r\n  }\r\n}\r\n@media all and (max-width: 1300px) {\r\n  .drawer {\r\n    width: 290px;\r\n  }\r\n  .userInfoContainer {\r\n    width: 290px;\r\n  }\r\n}\r\n@media all and (max-width: 1100px) {\r\n  .drawer {\r\n    width: 360px;\r\n  }\r\n  .userInfoContainer {\r\n    width: calc(100% - 23px);\r\n  }\r\n}\r\n@media all and (max-width: 600px) {\r\n  .drawer {\r\n    width: 300px;\r\n  }\r\n  .userInfoContainer {\r\n    width: 300px;\r\n  }\r\n}\r\n@media all and (max-width: 400px) {\r\n  .drawer {\r\n    width: calc(100% - 2px);\r\n  }\r\n  .userInfoContainer {\r\n    width: calc(100% - 20px);\r\n    padding-inline-end: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `ThemeSidebar_drawer__YAobF`,
	"allSystemsContainer": `ThemeSidebar_allSystemsContainer__cexlt`,
	"selectedSystem": `ThemeSidebar_selectedSystem__tsnMp`,
	"hideSelectedSystem": `ThemeSidebar_hideSelectedSystem__+4Xd9`,
	"showSelectedSystem": `ThemeSidebar_showSelectedSystem__TcTF0`,
	"showAllSystems": `ThemeSidebar_showAllSystems__6JeGX`,
	"hideAllSystems": `ThemeSidebar_hideAllSystems__UzMqW`,
	"systemContainer": `ThemeSidebar_systemContainer__CWKEg`,
	"dashBoardContainer": `ThemeSidebar_dashBoardContainer__IJVse`,
	"corrector": `ThemeSidebar_corrector__8gFPv`,
	"correctorParts": `ThemeSidebar_correctorParts__k4Wwu`,
	"drawerIncorrectLtr": `ThemeSidebar_drawerIncorrectLtr__sUW+8`,
	"drawerIncorrectRtl": `ThemeSidebar_drawerIncorrectRtl__8+EmZ`,
	"rtlDirectionCorrector": `ThemeSidebar_rtlDirectionCorrector__BFCXB`,
	"ltrDirectionCorrector": `ThemeSidebar_ltrDirectionCorrector__0DE3h`,
	"drawerAndTogglerContainer": `ThemeSidebar_drawerAndTogglerContainer__OjCbw`,
	"togglerIconContainer": `ThemeSidebar_togglerIconContainer__tgEDj`,
	"rtlSystemArrow": `ThemeSidebar_rtlSystemArrow__iexnN`,
	"ltrSystemArrow": `ThemeSidebar_ltrSystemArrow__quQ1b`,
	"whiteTheme": `ThemeSidebar_whiteTheme__YgIdr`,
	"gradientTheme": `ThemeSidebar_gradientTheme__UK3M3`,
	"pinkTheme": `ThemeSidebar_pinkTheme__zUwnW`,
	"darkTheme": `ThemeSidebar_darkTheme__ZJ7Sp`,
	"BlueTheme": `ThemeSidebar_BlueTheme__ke09v`,
	"whiteBGC": `ThemeSidebar_whiteBGC__Ob48Z`,
	"gradientBGC": `ThemeSidebar_gradientBGC__HM-Rt`,
	"pinkBGC": `ThemeSidebar_pinkBGC__TeTQk`,
	"darkBGC": `ThemeSidebar_darkBGC__jq5Pi`,
	"BlueBGC": `ThemeSidebar_BlueBGC__ZtW5g`,
	"logoContainer": `ThemeSidebar_logoContainer__HFbvi`,
	"logo": `ThemeSidebar_logo__nEvwW`,
	"systemTitleContainer": `ThemeSidebar_systemTitleContainer__rXEjE`,
	"darkThemeSystemTitleContainer": `ThemeSidebar_darkThemeSystemTitleContainer__DwNFA`,
	"BarkThemeSystemTitleContainer": `ThemeSidebar_BarkThemeSystemTitleContainer__Mxges`,
	"systemTitle": `ThemeSidebar_systemTitle__7AcRz`,
	"searchInputContainer": `ThemeSidebar_searchInputContainer__oU2tH`,
	"allSystemSearchContainer": `ThemeSidebar_allSystemSearchContainer__TKbR8`,
	"searchLabel": `ThemeSidebar_searchLabel__8pW5n`,
	"allSystemSearchInput": `ThemeSidebar_allSystemSearchInput__M+hcc`,
	"searchInput": `ThemeSidebar_searchInput__GkaZa`,
	"allSystemSearchplaceholder": `ThemeSidebar_allSystemSearchplaceholder__nWmdc`,
	"placeholder": `ThemeSidebar_placeholder__mBo8F`,
	"searchIcon": `ThemeSidebar_searchIcon__cufuh`,
	"navigationContainer": `ThemeSidebar_navigationContainer__5Bd7i`,
	"line": `ThemeSidebar_line__xyXNK`,
	"allSystemLine": `ThemeSidebar_allSystemLine__QGZFx`,
	"constPartContainer": `ThemeSidebar_constPartContainer__0pGO5`,
	"userInfoContainer": `ThemeSidebar_userInfoContainer__DcO93`,
	"userInfoContainerRtlLan": `ThemeSidebar_userInfoContainerRtlLan__dxk0w`,
	"userInfoContainerLtrLan": `ThemeSidebar_userInfoContainerLtrLan__uo7md`,
	"toggler": `ThemeSidebar_toggler__o9zrm`,
	"ltrOpenedToggler": `ThemeSidebar_ltrOpenedToggler__hZ9VG`,
	"ltrClosedToggler": `ThemeSidebar_ltrClosedToggler__ULe6k`,
	"rtlOpenedToggler": `ThemeSidebar_rtlOpenedToggler__Jz7Uu`,
	"rtlClosedToggler": `ThemeSidebar_rtlClosedToggler__Ojum+`,
	"ltrSystemTitleToggler": `ThemeSidebar_ltrSystemTitleToggler__ZOPo+`,
	"rtlSystemTitleToggler": `ThemeSidebar_rtlSystemTitleToggler__jrs1j`
};
export default ___CSS_LOADER_EXPORT___;
